import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('thirrsty_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Pass through; pages handle errors
    return Promise.reject(err);
  }
);

export const setToken = (token) => {
  if (token) localStorage.setItem('thirrsty_token', token);
  else localStorage.removeItem('thirrsty_token');
};

export const getToken = () => localStorage.getItem('thirrsty_token');
